import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { isUserTokenValid } from 'entities/Auth/sdk';
import { getUrlGetParams } from 'utils/urls';

import AuthPage from 'components/AuthPage';

import SetPasswordForm from './SetPasswordForm';
import ResendResetLinkForm from './ResendResetLinkForm';

const SetPassword = () => {
  const { token = '', email = '' } = getUrlGetParams();
  const [isValidToken, setIsValidToken] = useState<boolean | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    isUserTokenValid({ email, token })
      .then(() => setIsValidToken(true))
      .catch((error) => {
        if (error.response.status === 404 || error.response.status === 422) {
          navigate('/not-found');
        }
        setIsValidToken(false);
      });
  }, [token, email, navigate]);

  return (
    <AuthPage>
      <div className='flex flex-col justify-center w-full'>
        {/* TODO: show loading animation when loading */}
        {isValidToken && <SetPasswordForm email={email} token={token} />}
        {isValidToken === false && <ResendResetLinkForm email={email} />}
      </div>
    </AuthPage>
  );
};

export default SetPassword;
